<script>
    import { clickOutside } from "@/lib/utils"
    import { onMount, tick } from "svelte"
    import { link, navigate } from "svelte-routing";
    import { writable } from "svelte/store";
    import { service as contentpageService } from "@/services/contentpage";
    import { translate } from "@/lib/utils"

    export let hide = false
    export let sidebarOpen = false

    const contentpages = writable();

    onMount( async () => {
        await tick()

        await contentpageService.index({
            params: {
                show_in_header: 1,
            }},
            contentpages
        );
    })
    
    const toggleSidebar = () => sidebarOpen = !sidebarOpen
</script>

<main class="fixed top-0 w-[inherit] max-w-[2000px] z-50 {hide ? 'hidden' : ''}">
    <div class="flex flex-row items-center text-white {sidebarOpen ? '' : 'bg-black/50'}">
        <div class="container mx-auto">
            <div class="py-6">
                <div class="flex flex-row items-center justify-between w-full h-full">
                    {#if window.meta.logo}
                        <a href="/" use:link class="relative shrink-0">
                            <img class="h-12 lg:h-14 w-auto object-contain" src={window.meta.logo} alt="logo"/>
                        </a>
                    {/if}

                    <div class="w-full p-2 hidden lg:block">
                        <div class="flex flex-row gap-4 justify-center">
                            {#if $contentpages?.data?.length > 0}
                                {#each $contentpages.data as contentpage, index}
                                    {#if contentpage}
                                        <a use:link href="/{contentpage.slug}" title="{translate(contentpage.title)}" class="underline uppercase decoration-transparent hover:decoration-white underline-offset-2 transition-all">
                                            <span>{translate(contentpage.title)}</span>
                                        </a>
                                    {/if}
                                {/each}
                            {/if}
                        </div>
                    </div>

                    <div class="hidden lg:block shrink-0">
                        <a href="https://paypal.me/homefoundationde" target="_blank" class="button primary">
                            <span>
                                Spenden
                            </span>
                        </a>
                    </div>

                    <div class="flex flex-row gap-8 h-full shrink-0 lg:hidden rounded-xl">
                        <div use:clickOutside on:click_outside={() => sidebarOpen = false} class="flex items-center">
                            <button aria-label="Menu" on:click="{toggleSidebar}" class="flex items-center justify-center outline-none focus:outline-none appearance-none relative cursor-pointer w-10 h-10">
                                <div class="relative w-8 h-8 flex justify-center items-center">
                                    <span class="block absolute right-1 left-1 h-0.5 transform transition duration-500 ease-in-out bg-white {sidebarOpen ? 'rotate-45 w-6' : 'w-6 -translate-y-1.5'}"/>
                                    <span class="block absolute right-1 left-1 h-0.5 transform transition duration-500 ease-in-out bg-white {sidebarOpen ? '-rotate-45 w-6' : 'w-6 translate-y-1.5'}"/>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>

<div class="bg-black/80 backdrop-blur-sm ease-in-out transition-translate duration-300 fixed left-0 right-0 top-0 bottom-0 w-full z-40 transform {sidebarOpen ? 'block' : 'hidden'}">
    <div class="my-3 text-white mt-28">
        <div class="container mx-auto">
            <div class="flex flex-col h-full">
                <div class="flex flex-col gap-2 lg:text-xl">
                    {#if $contentpages?.data?.length > 0}
                        {#each $contentpages.data as contentpage, index}
                            {#if contentpage}
                                <a on:click={() => sidebarOpen = false} use:link href="/{contentpage.slug}" title="{translate(contentpage.title)}" class="underline uppercase decoration-transparent hover:decoration-white underline-offset-2 transition-all text-2xl">
                                    <span>{translate(contentpage.title)}</span>
                                </a>
                            {/if}
                        {/each}
                    {/if}

                    <a href="https://paypal.me/homefoundationde" target="_blank" class="button primary mt-4">
                        <span>
                            Spenden
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>